import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchPDDAppIDRecalled = createAsyncThunk(
    'fetchPDDAppIDRecalled',
    async ({ jwtBearer }) => {
        const response = await fetch(`${BASE_URL}pdd/get/app/id/recalled/`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const pddDataRecalledSlice = createSlice({
    name: 'pddDataRecalledSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchPDDAppIDRecalled.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchPDDAppIDRecalled.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchPDDAppIDRecalled.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default pddDataRecalledSlice.reducer
